<template>
  <nav
    class="fixed top-0 left-0 z-40 w-full bg-white shadow-md transition-all duration-300 flex items-center"
    :style="{ height: '80px' }"
  >
    <div
      class="container mx-auto px-4 flex items-center justify-between h-full"
    >
      <!-- Left Side: Logo & Location Skeleton -->
      <div class="flex items-center gap-4 md:gap-6">
        <div class="flex items-center gap-3">
          <!-- Logo Skeleton -->
          <div class="w-14 h-14 rounded-full bg-gray-200 animate-pulse"></div>
          <!-- Store Name Skeleton -->
          <div class="hidden sm:block">
            <div class="h-4 w-32 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        <!-- Location Skeleton -->
        <div class="flex items-center gap-2 pl-2 pr-4 py-1.5 rounded-full">
          <div class="h-10 w-48 bg-gray-200 rounded-full animate-pulse"></div>
        </div>
      </div>

      <!-- Right Side: Cart Button Skeleton -->
      <div class="flex items-center gap-3">
        <div
          class="flex items-center gap-2 px-4 py-2 h-10 w-28 rounded-full bg-gray-200 animate-pulse"
        ></div>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: "NavbarSkeleton"
};
</script>
